<app-layout-main [pageMetadata]="{ title: appName() }" [layoutSize]="'small'" [design]="'focused'">
	<lib-focused-card [title]="'Login'">
		<ui-text-form-field
			[title]="'E-mail'"
			[isRequired]="true"
			[validation]="'email'"
			[valueAsSignal]="form.email"
			[maxLength]="50"
		></ui-text-form-field>

		<ui-text-form-field
			class="push-top-md"
			[title]="'Password'"
			[textType]="'password'"
			[isRequired]="true"
			[valueAsSignal]="form.password"
			[maxLength]="30"
		></ui-text-form-field>

		<ui-form-save-button
			[title]="'Continue'"
			[removeDivider]="true"
			[saveHandler]="saveHandler()"
			[enableEnterSaveShortcut]="true"
			[logHandler]="formLogHandler()"
		></ui-form-save-button>

		<div class="push-top">
			<lib-link [routerLink]="forgottenPasswordRouterLink" [linkStyle]="'default'"
				>Forgot your password?</lib-link
			>
		</div>
	</lib-focused-card>
</app-layout-main>
